const i = {
  size: "medium",
  variant: "primary",
  fullWidth: !1,
  isLoading: !1
};
export { i as buttonDefaultProps };